var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"size":"mini","placeholder":"请选择类型"},on:{"change":_vm.changeValue},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item[0],ref:"option",refInFor:true,attrs:{"label":item[0],"value":item[0]}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }